import { Stack } from 'components/Stack';
import { Attachment } from 'components/MerchantTrackingWidget/components/Attachment';
import { useTranslation } from 'react-i18next';
import { ReturnAttachment } from '../../../../interfaces/ReturnRequest.interface';
import { Heading } from './AttachmentsSection.styles';

interface AttachmentsSectionProps {
  attachments: ReturnAttachment[];
}

export const AttachmentsSection = ({
  attachments,
}: AttachmentsSectionProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" gap={8} isFullWidth>
      <Heading>{`${t('RETURN_ATTACHMENTS')}:`}</Heading>
      {attachments?.length
        ? attachments.map((item) => {
            return (
              <Attachment
                fileName={item.name}
                downloadUrl={item.url}
                downloadable
              />
            );
          })
        : '-'}
    </Stack>
  );
};
